import { NOTIFICATION } from 'context/constants';

const init = { message: '', variant: '' }

export default (state = init, { type, ...notification }) => {
  switch (type) {
    case NOTIFICATION:
      return notification;
    default:
      return state;
  }
}